import React, { Component } from 'react';
import { Redirect } from 'react-router';

class NotFound extends Component{
    render(){
        return(
            <Redirect to ="/" />
            // <MainContainer>
            // <hi className= "page-header"> Not Found </hi>
            // <span> Page is not found </span>
            // </MainContainer>
        )
    }
}
export default NotFound;


// WEBPACK FOOTER //
// ./src/NotFound.js